import './FilterTreeHorizontalPlaceholder.scss';

import PlaceholderItem from '@components/PlaceHolderItem';
import { appendClassNames, createClsNameMap } from '@utils';

export const clsNameMap = createClsNameMap({
  elements: {
    list: createClsNameMap({}),
    item: createClsNameMap({}),
    btn: createClsNameMap({}),
    icon: createClsNameMap({}),
  },
})('filter-tree-horizontal-placeholder');

export type PlaceholderProps = {
  className?: string;
  rows?: number;
};

const FilterTreeHorizontalPlaceholder = ({ className, rows = 4 }: PlaceholderProps) => {
  const arr = new Array(rows).fill('item');
  return (
    <div className={appendClassNames(clsNameMap.root(), className)}>
      <ul className={clsNameMap.elm('list')}>
        {arr.map((_, i) => {
          return (
            <li key={i} className={clsNameMap.elm('item')}>
              <button aria-label='placeholder loading' className={clsNameMap.elm('btn')}>
                <PlaceholderItem modifiers={['width3']} />
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='7'
                  height='12'
                  role='img'
                  viewBox='0 0 7 12'
                  fill='#222222'
                  className={clsNameMap.elm('icon')}
                >
                  <path d='M6.58942 0.610713C6.26398 0.285274 5.73635 0.285274 5.41091 0.610713L0.611415 5.41021C0.455135 5.56649 0.366829 5.77895 0.366829 5.99996C0.366829 6.22098 0.454629 6.43294 0.610909 6.58922L5.41091 11.3892C5.73635 11.7147 6.26398 11.7147 6.58942 11.3892C6.91486 11.0638 6.91486 10.5362 6.58942 10.2107L2.37867 5.99996L6.58942 1.78922C6.91486 1.46379 6.91486 0.936153 6.58942 0.610713Z' />
                </svg>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FilterTreeHorizontalPlaceholder;
